var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import C from 'classnames';
export const TableHeaderRow = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("tr", Object.assign({ className: C(className) }, props), props.children));
};
//# sourceMappingURL=TableHeaderRow.js.map